import {Component, OnInit, Output, ViewContainerRef} from '@angular/core';
import {Table} from "../../shared/model/table";
import {TableService} from "../../shared/services/table/table.service";
import {Restaurant} from "../../shared/model/restaurant";
import {Router, ActivatedRoute} from "@angular/router";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {Overlay} from "angular2-modal";
import {ionicConfig} from "../../../environments/ionic2.config";

@Component({
  selector: 'table-table',
  templateUrl: './table-table.component.html',
  styleUrls: ['./table-table.component.css']
})

export class TableTableComponent implements OnInit {
  private tables: Table[];

  public rows: Array<any> = [];
  public columns: Array<any> = [
    {
      title: 'Table',
      name: 'tableName',
      filtering: {filterString: '', placeholder: 'Filter by name / number'},
      sort: 'asc'
    },
      {
      title: 'Status',
      className: ['status-header', 'text-success'],
      name: 'statusForTable',
      sort: '',
      filtering: {filterString: '', placeholder: 'Filter by status.'},
       },
    {
      title: 'Seats',
      className: 'text-warning',
      // filtering: {filterString: '', placeholder: 'Filter by seats.'},
      name: 'seats',
      sort: '',
    },
 /*   {
      title: 'Active',
      className: 'text-warning',
      // filtering: {filterString: 'true', placeholder: 'Filter by Active.'},
      name: 'isActive',
      sort: '',
      selectable: true
    },
 */

    {title: '', ClassName: 'edit', name: 'edit', sort: ''},
  ];
  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 10;
  public numPages: number = 1;
  public length: number = 0;

  public config: any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {
      filterString: ''
  },
    className: ['table-striped', 'table-bordered' ,'ng-table']
  };

  private data: Array<any>;


  @Output('table')


  private currentRestaurant: Restaurant;
  private currentRestaurantId: string;
   currentRestaurantName: string;
  private qrCode:any;


  constructor(private tableservice: TableService,
              private router: Router,
              private route:ActivatedRoute,
              public modal:Modal,
              overlay: Overlay,
              vcRef:ViewContainerRef
  ) {

    // console.log("tables");
  }

  ngOnInit() {

    this.data = [];


    let isEmpty:boolean

    this.route.data
      .subscribe( ( data : {restaurant:Restaurant  }) =>
      {
        isEmpty = !data.restaurant
        if (!isEmpty) {

          this.currentRestaurant = data.restaurant;
          this.currentRestaurantId = data.restaurant.$key;
          this.currentRestaurantName = data.restaurant.restaurant;
         this.tableservice.getTables(this.currentRestaurantId)
            .subscribe((tables) => {
              this.tables = tables;
              this.data = this.tables;
              this.length = this.data.length;
              this.onChangeTable(this.config);

            });
        }else{
        }

      })

  }

  onRestaurantEmitter(restaurant:Restaurant){



    this.currentRestaurant = restaurant;
    this.currentRestaurantId = restaurant.$key;
    this.currentRestaurantName = restaurant.restaurant;
    this.tableservice.getTables(this.currentRestaurantId)
      .subscribe((tables) => {
        this.tables = tables;
        this.data = this.tables;
        this.length = this.data.length;
        this.onChangeTable(this.config);

      });

  }

  markAllTablesEmpty(){

    this.modal.confirm()
        .size('lg')
        .showClose(true)
        .title('Changing all ' + this.currentRestaurantName + ' tables to Empty' )
        .body('Please OK to mark all tables Empty')
        .open()
        .catch((err: any) => console.log('ERROR: ' + err))
        .then((dialog: any) => { return dialog.result })
        .then((result: any) => { this.markAllTablesEmptyEvent() })
        .catch((err: any) => this._cleanup());

  }

  _cleanup(){
  }





  markAllTablesEmptyEvent(){
    this.tableservice.setAllTablesEmpty(this.currentRestaurantId);
  }


  createMultipeTables(){

    let navigateRoute = '/tables/createMultiple/'+this.currentRestaurantId;
    this.router.navigate([navigateRoute])
        .then();


  }


  getFirstTable(){
  }


  seeTablesRatings(){
    let navigateRoute = '/tables/TablesRatings/'+this.currentRestaurantId;
    this.router.navigate([navigateRoute])
      .then();
  }

  printAllRQCodes(){


    let navigateRoute = '/tables/PrintQRCodes/'+this.currentRestaurantId;
    this.router.navigate([navigateRoute])
        .then();


  }


  createTable(){

    let navigateRoute = '/tables/create/'+this.currentRestaurantId;
    this.router.navigate([navigateRoute])
      .then();

  }

  public onCellClick(data: any): any {




    this.tableservice.setCurrentTable(data.row);


    // console.log(data.row);


    if (data.column == "edit") {


      let tableId = data.row.$key;

      let navigateRoute = '/tables/' + tableId + '/edit';
      this.router.navigate([navigateRoute])
        .then();
    }


  }


  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name].toString().match(this.config.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }


  public onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

}



// WEBPACK FOOTER //
// ./src/app/table/table-table/table-table.component.ts